import { useTranslation } from 'react-i18next';

export function LangToggle() {
  const { i18n, t } = useTranslation();
  const next = i18n.language.startsWith('th') ? 'en' : 'th';
  return (
    <button
      type="button"
      aria-label="Toggle language"
      className="rounded-pill px-3 py-2 text-sm font-semibold text-ink-soft hover:bg-soi-100"
      onClick={() => void i18n.changeLanguage(next)}
    >
      {t('lang.toggle')}
    </button>
  );
}
